module.exports = __webpack_public_path__ + "img/card_barcellona_background.fbe4952a.png";